export class BaseListBase<T> {
  public items: Array<T>;
  public total_count: number;
  public filtered_count: number;
}
